/**
 * Global fetch interceptor for JWT authentication.
 * Call setupFetchInterceptor() once at app startup.
 * All subsequent fetch() calls to /api/* will automatically include the JWT token.
 */

const TOKEN_KEY = 'impulse_token';

let _interceptorInstalled = false;

export function setupFetchInterceptor() {
  if (_interceptorInstalled) return;
  _interceptorInstalled = true;

  const originalFetch = window.fetch;

  window.fetch = function (url, options = {}) {
    const token = localStorage.getItem(TOKEN_KEY);

    // Only add auth header for API calls (not external URLs or static assets)
    const isApiCall = typeof url === 'string' && (
      url.startsWith('/api') ||
      url.includes('/api/')
    );

    if (token && isApiCall) {
      options = { ...options };
      options.headers = {
        ...(options.headers || {}),
        'Authorization': `Bearer ${token}`
      };
    }

    return originalFetch.call(window, url, options).then(response => {
      // Auto-logout ONLY on HARD JWT failures (expired/invalid — NOT missing).
      // "Token manquant" is NOT included here: a transient missing-token error
      // (e.g. race between login & initial API calls) should not wipe the session.
      if (response.status === 401 && isApiCall) {
        const HARD_JWT_ERRORS = ['Token expiré', 'Token invalide'];
        response.clone().json().then(data => {
          if (data && HARD_JWT_ERRORS.includes(data.error)) {
            console.warn('[AUTH-INTERCEPTOR] JWT hard 401 → auto-logout:', url, data.error);
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem('impulse_auth');
            window.location.reload();
          } else {
            console.log('[AUTH-INTERCEPTOR] Soft 401 (ignored):', url, data?.error);
          }
        }).catch(() => {
          console.log('[AUTH-INTERCEPTOR] Non-JSON 401 (ignored):', url);
        });
      }
      return response;
    });
  };
}
